import React, { useEffect, useState } from 'react'

import CrosswordOpenGame from './CrosswordOpen'
import { demoGameStatus, demoProfileInfo, demoSubjectAccessList } from 'Components/Civics/EscapeRoom/openGameUtil'

const CrossWordGameLoad = () => {
    const [isLoaded, setIsLoaded] = useState(false)

    const role = localStorage.getItem("role")

    useEffect(() => {
        setGameDataToLocalStorage()

        return () => {
            localStorage.clear()
        }
        //eslint-disable-next-line
    }, [])

    useEffect(() => {
        if (role) {
            setTimeout(() => {
                setIsLoaded(true)
            }, 100);
        }
        //eslint-disable-next-line
    }, [role])

    function setGameDataToLocalStorage() {
        // ✅ Store everything in localStorage
        localStorage.setItem("gamesStatus", JSON.stringify(demoGameStatus));
        localStorage.setItem("profileInfo", JSON.stringify(demoProfileInfo));
        localStorage.setItem("role", role);
        localStorage.setItem("subjectAccessList", JSON.stringify(demoSubjectAccessList));
    }

    return (
        <div>
            {isLoaded ? <CrosswordOpenGame /> : <div></div>}
        </div>
    )
}

export default CrossWordGameLoad
